import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

const LikelihoodRecord = Record({
  label: '',
  badges: [],
});

export default class Likelihood extends LikelihoodRecord {
  static deserialize(jsonObject = {}) {
    const mapProperties = {
      badges: Hydrator.fromArray(Number),
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new Likelihood(hydrated);
  }
}
